// TaxiCaller's own webhook/API data sometimes sends a passenger's FULL name
// in the "first name" field, with their surname repeated separately in
// "last name" -- e.g. Passenger_First_Name = "Ron Whitty",
// Passenger_Last_Name = "Whitty". Confirmed (2026-09) against the live
// taxicaller_data table: this affects ~17% of jobs over a 2-month sample,
// spans many different accounts/drivers/fleets, so it's a TaxiCaller-side
// data-entry/field-mapping quirk on a subset of bookings, not a DMS bug --
// but every screen that joins the two fields for display was showing the
// surname twice ("Ron Whitty Whitty") as a result. This is the one place
// that join happens now, so the whole app stays in sync.
//
// Two database views build a `passenger_name` column server-side instead
// of going through this function -- export_builder_jobs (Export Builder)
// and invoiced_jobs_view (already-invoiced job history). Both carry a SQL
// CASE expression mirroring the same logic; if this function's behaviour
// ever changes, update those views to match (see migrations
// dedupe_passenger_name_in_export_builder_jobs_view and
// dedupe_passenger_name_in_invoiced_jobs_view).
export function formatPassengerName(
  first?: string | null,
  last?: string | null
): string {
  const f = (first || "").trim();
  const l = (last || "").trim();
  if (!f) return l;
  if (!l) return f;
  // Only drop the surname if it's genuinely a trailing duplicate (e.g.
  // "Ron Whitty" ends with "Whitty") -- never drop it just because the two
  // strings happen to share letters.
  if (f.toLowerCase().endsWith(l.toLowerCase())) return f;
  return `${f} ${l}`;
}
